import { Context } from '@vue-storefront/core';
import { ApiResult, CatList, GetCatParams, CatDetails } from '../../types';

export default async function getCategory(context: Context, params: GetCatParams): Promise<ApiResult> {
  const url = new URL('/mall/cat/list', context.config.api.url);
  const { data: res } = await context.client.post(url.href, { shop_id: params.shopId });
  const CatListData = [];
  if (res.code === 0) {
    const result = res.data;
    if (result && result.list) {
      result.list.forEach((x) => {
        const catInfo: CatList = {
          catId: x.cat_id,
          shopId: x.shop_id,
          name: x.name,
          pCatId: x.p_cat_id,
          weight: x.weight,
          imageUrl: x.image_url,
          count: x.count,
          slug: x.slug,
          subCats: []
        };
        if (x.sub_cats) {
          x.sub_cats.forEach((y) => {
            const subCatInfo: CatDetails = {
              catId: y.cat_id,
              shopId: y.shop_id,
              name: y.name,
              pCatId: y.p_cat_id,
              weight: y.weight,
              imageUrl: y.image_url,
              count: y.count,
              slug: y.slug,
              isSub: y.is_sub,
            };
            catInfo.subCats.push(subCatInfo);
          });
        }
        CatListData.push(catInfo);
      });
    }
  }
  res.data = CatListData;
  return res;
}
